var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconDao = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-community-16-regular",
    transform: "translate(-12 -11.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6463",
    "data-name": "Group 6463",
    transform: "translate(12 11.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11700",
    "data-name": "Path 11700",
    d: "M19.286,19.285a7.286,7.286,0,1,1,7.286,7.286A7.286,7.286,0,0,1,19.286,19.285Zm7.286-3.643a3.643,3.643,0,1,0,3.643,3.643A3.643,3.643,0,0,0,26.571,15.642Zm17.409,9.413A7.286,7.286,0,1,1,54.2,23.732a7.286,7.286,0,0,1-10.221,1.323Zm4.448-9.413a3.643,3.643,0,1,0,3.643,3.643A3.643,3.643,0,0,0,48.429,15.642ZM17.464,30.213h9.726a10.974,10.974,0,0,0-.619,3.643H17.464a1.821,1.821,0,0,0-1.821,1.821A8.194,8.194,0,0,0,18.7,42.362a10.251,10.251,0,0,0,3.056,1.658,9.107,9.107,0,0,0-1.938,3.162,13.6,13.6,0,0,1-3.4-1.978A11.842,11.842,0,0,1,12,35.678,5.464,5.464,0,0,1,17.464,30.213Zm13.726,0a7.289,7.289,0,1,0,9.956-2.67A7.289,7.289,0,0,0,31.191,30.213Zm5.493.091A3.643,3.643,0,1,1,33.9,34.4,3.654,3.654,0,0,1,36.684,30.3ZM56.3,42.362a10.25,10.25,0,0,1-3.056,1.658,9.107,9.107,0,0,1,1.934,3.162,13.793,13.793,0,0,0,3.4-1.978A11.842,11.842,0,0,0,63,35.678a5.464,5.464,0,0,0-5.464-5.464H47.809a10.974,10.974,0,0,1,.619,3.643h9.107a1.821,1.821,0,0,1,1.821,1.821A8.194,8.194,0,0,1,56.3,42.362Zm-9.7,2.423a5.464,5.464,0,0,1,5.464,5.464,11.831,11.831,0,0,1-4.415,9.526A16.144,16.144,0,0,1,37.5,63a16.144,16.144,0,0,1-10.156-3.224,11.842,11.842,0,0,1-4.415-9.526,5.45,5.45,0,0,1,5.464-5.464Zm0,3.643H28.393a1.821,1.821,0,0,0-1.821,1.821,8.194,8.194,0,0,0,3.053,6.685A12.532,12.532,0,0,0,37.5,59.356a12.532,12.532,0,0,0,7.876-2.423,8.194,8.194,0,0,0,3.053-6.685A1.821,1.821,0,0,0,46.607,48.428Z",
    transform: "translate(-12 -11.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    transform: "translate(31 27.5)",
    fill: "none",
    stroke: "#f69139",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dao.ef9d49a9.svg";
export { ForwardRef as ReactComponent };